import {
  React,
  Component,
  PropTypes,
  helpers
} from 'imports/CommonImports';

import {
  PrimaryColor1,
  SuccessColorLight,
  GreyColor1,
  GreyColor2,
  ShadowColor,
} from 'imports/DesignImports';


import ReactHighcharts from 'react-highcharts';

import {
  Paper,
} from 'material-ui';


const styles = {
  pageContainer: {
    padding: '0px 25px'
  },
}

class StackedGraph extends Component {
  constructor(props){
    super(props);
    const years = props.yearsBaus.map(baus => baus.year);
    const BAUData = props.yearsBaus.map(baus => baus.bau);
    const innovationData = props.data.map(data => data.value);
    const bau = {
      name: "BAU",
      data: BAUData
    };
    const innovation = {
      name: "i3",
      data: innovationData
    };
    const series = [innovation, bau];
    const i3PerYear = innovationData.map((data, index) => {
      return Number(data / (BAUData[index] + data)).toFixed(4) * 100;
    });
    this.state = {
      years,
      series,
      i3PerYear,
      colors: [SuccessColorLight,  PrimaryColor1, GreyColor1],
    }
  }

  render() {
    return (
      <Paper style={{...styles.pageContainer, ...this.props.style}}>
        <p style={styles.header}><b>{this.props.header}</b></p>
        <ReactHighcharts config={this.config(this.state.extra)} ref="chart" style={{minHeight:"400px"}} />
      </Paper>
    );
  }

  config = (extra) => { return({
    chart: {
        zoomType: 'xy',
        backgroundColor: GreyColor2,
    },
    title: {
      text: '',
    },
    xAxis: {
        categories: this.state.years,
        crosshair: true
    },
    yAxis: [
      {
        min: 0,
        title: {
            text: `${this.props.indicator} (${this.props.currency})`,
        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: 'bold',
                color: (ReactHighcharts.theme && ReactHighcharts.theme.textColor) || 'gray'
            },
            formatter: function () {
              // return "$ "+ helpers.numberWithDots((Number(this.cumulative) / 1000000).toFixed(1)).replace('.',',') + "M";
              return "";
            }
        },
      },
      {
        min: 0,
        title: {
            text: "i3",
        },
        opposite: true,
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color: (ReactHighcharts.theme && ReactHighcharts.theme.textColor) || 'white',
          },
          formatter: function () {      
            return this.cumulative + "%";
          }
        },
        labels: {
          format: '{value}%'
        }
      },
    ],
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
        enabled: true
    },
    plotOptions: {
        column: {
            dataLabels: {
                enabled: true,
                color: (ReactHighcharts.theme && ReactHighcharts.theme.dataLabelsColor) || 'white',
                formatter: function () {
                  return "$ "+ helpers.numberWithDots((Number(this.y) / 1000000).toFixed(1)).replace('.',',') + "M";
                }
            },
            allowPointSelect: true,
        },
        series: {
          stacking: 'normal'
        }
    },
    series: [{
      type: 'column',
      name: 'Innovación',
      yAxis: 0,
      data: this.state.series[0].data
    }, {
      type: 'column',
      name: 'BAU',
      yAxis: 0,
      data: this.state.series[1].data
    }, {
      type: 'spline',
      name: 'i3',
      yAxis: 1,
      data: this.state.i3PerYear
    }],
    credits: {
      enabled: false
    }
  })}
}

StackedGraph.propTypes = {
  style: PropTypes.object,
  data: PropTypes.array,
  header: PropTypes.string,
  indicator: PropTypes.string,
  currency: PropTypes.string,
};

StackedGraph.defaultProps = {
  style: {},
  data: [{option: 'N/A', values: [0,1,2]}, {option: 'N/A', values: [0,1,2]}, {option: 'N/A', values: [0,1,2]}],
  header: 'Sin datos',
  indicator: 'EBITDA',
  currency: 'CLP'
};

export default StackedGraph;



// WEBPACK FOOTER //
// ./src/components/dashboard/StackedGraph.js